import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useContext } from 'react';
import { getImageStylesAndSrc } from './helpers';
import ImgZoomable from './ImageZoomable';
import Img from './ImageBase';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { MatureContext } from '@wix/da-react-context/pkg/MatureContext';
import { useEditorContainerSize } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';
import HiddenDumbView from '../../../DeviationViews/Dumbo/Hidden/Hidden';
import EditorDeviationLink from '../_partials/DeviationLink';
import { SMALL_MEDIA_WIDTH } from '../constants';
const ImageView = (props)=>{
    const containerSize = useEditorContainerSize();
    const { deviation, extOptions, width: propsWidth, link } = props;
    const showMatureContent = useContext(MatureContext);
    const { isLoggedIn } = useContext(SessionContext);
    // Handle small media
    const width = (extOptions === null || extOptions === void 0 ? void 0 : extOptions.smallMedia) ? SMALL_MEDIA_WIDTH : propsWidth;
    if (!showMatureContent && deviation.isMature || deviation.isBlocked || deviation.isAntisocial && !isLoggedIn) {
        // We have extra check for anti-social because inside a saved editor
        // deviation we can have stale isBlocked value
        return /*#__PURE__*/ React.createElement(HiddenDumbView, _object_spread_props(_object_spread({}, props), {
            width: width !== null && width !== void 0 ? width : 780
        }));
    }
    const calculatedProps = getImageStylesAndSrc(deviation, width, extOptions, containerSize);
    if (!calculatedProps) {
        return null;
    }
    const { allowFullview, wrapperStyles, coverThumb, imgStyles } = calculatedProps;
    const ImageComponent = allowFullview ? ImgZoomable : Img;
    return /*#__PURE__*/ React.createElement(EditorDeviationLink, {
        style: wrapperStyles,
        link: link,
        deviation: deviation
    }, /*#__PURE__*/ React.createElement(ImageComponent, {
        file: coverThumb,
        deviation: deviation,
        imgStyles: imgStyles
    }));
};
ImageView.displayName = 'ImageView';
export default ImageView;

//# sourceMappingURL=Image.js.map